import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver-es';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class FileSaverService {
    constructor(private http: HttpClient) {}

    public saveFile(url: string, filename: string, type: string = ''): Observable<BlobPart> {
        return this.http
            .request<Blob>('get', url, {
                // @ts-ignore
                responseType: 'blob',
            })
            .pipe(
                tap((file: BlobPart) => {
                    saveAs(new Blob([file], type ? { type: type } : {}), filename);
                }),
                catchError((err) => {
                    return throwError(err);
                }),
            );
    }
}
